import { Component, Input } from '@angular/core';
import { AssetModule } from '../../../Compliance/Asset/asset.module';
import { PanelChevronComponent } from '../../../UI-Lib/Weissman-Panel/panel.chevron.component';
import { AceLoaderComponent } from '../../../UI-Lib/ACE/Loader/loader.component';

@Component({
    selector: 'asset-list-panel',
    templateUrl: './assetListPanel.component.html',
    imports: [AceLoaderComponent, PanelChevronComponent, AssetModule],
})
export class AssetListPanelComponent {
    @Input() companyId: number;
    @Input() parcelId: number;
    @Input() siteId: number;
    @Input() showComplianceInfo: boolean;
    @Input() company: Core.CompanyModel;

    onLoading: boolean = true;
    hasViewPermission: boolean = true;
    showBody: boolean = false;

    expandOrCollapse(): void {
        this.showBody = !this.showBody;
    }
}
